export const COMPANY = {
  legalName: "Thai Notary Law & Service Co., Ltd.",
  brandName: "Thai Notary Phuket",
  registrationNumber: "04045565001923",
  phone: "094-895-8999",
  phoneIntl: "+66948958999",
  lineId: "@THAINOTARY",
  email: "Contact@thainotary.co.th",
  websites: ["https://www.thainotary.co.th", "https://www.thainotarylaw.com"],
  trustLine: "ทนาย Notarial Services Attorney ขึ้นทะเบียนสภาทนายความแห่งประเทศไทย",
  yearsExperience: 8,
  documentsHandled: 6500,
  responseTime: "ภายใน 30 นาที",
  hours: "จันทร์–อาทิตย์ 08:00–20:00",
} as const;

export const BRANCHES = [
  {
    id: "phuket-town",
    name: "สาขาเมืองภูเก็ต (สำนักงานใหญ่)",
    nameEn: "Phuket Town Head Office",
    address:
      "ถนนเฉลิมพระเกียรติ ร.๙ ตำบลตลาดใหญ่ อำเภอเมืองภูเก็ต จังหวัดภูเก็ต 83000",
    addressEn:
      "Chalermprakiat Rama 9 Rd., Talat Yai, Mueang Phuket, Phuket 83000",
    locality: "Phuket",
    region: "Mueang Phuket",
    postalCode: "83000",
    mapUrl: "https://maps.google.com/?q=Phuket+Town+Old+Town",
    isPrimary: true,
  },
  {
    id: "patong",
    name: "จุดบริการป่าตอง (Patong Service Point)",
    nameEn: "Patong Service Point",
    address: "ถนนราษฎร์อุทิศ 200 ปี ตำบลป่าตอง อำเภอกะทู้ จังหวัดภูเก็ต 83150",
    addressEn: "Rat-U-Thit 200 Pi Rd., Patong, Kathu, Phuket 83150",
    locality: "Patong",
    region: "Kathu",
    postalCode: "83150",
    mapUrl: "https://maps.google.com/?q=Patong+Beach+Phuket",
    isPrimary: false,
  },
  {
    id: "cherngtalay",
    name: "จุดบริการลากูน่า–เชิงทะเล",
    nameEn: "Laguna–Cherngtalay Service Point",
    address: "ถนนศรีสุนทร ตำบลเชิงทะเล อำเภอถลาง จังหวัดภูเก็ต 83110",
    addressEn: "Srisoonthorn Rd., Cherngtalay, Thalang, Phuket 83110",
    locality: "Cherngtalay",
    region: "Thalang",
    postalCode: "83110",
    mapUrl: "https://maps.google.com/?q=Laguna+Phuket",
    isPrimary: false,
  },
  {
    id: "chalong",
    name: "จุดบริการอ่าวฉลอง (Yacht & Marine)",
    nameEn: "Chalong Bay Marine Service Point",
    address: "ถนนเจ้าฟ้าตะวันออก ตำบลฉลอง อำเภอเมืองภูเก็ต จังหวัดภูเก็ต 83130",
    addressEn: "Chao Fah East Rd., Chalong, Mueang Phuket, Phuket 83130",
    locality: "Chalong",
    region: "Mueang Phuket",
    postalCode: "83130",
    mapUrl: "https://maps.google.com/?q=Chalong+Bay+Phuket",
    isPrimary: false,
  },
] as const;
